import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Icon, Button, Badge, Panel, PageHead, EmptyState, DecisionBadge, DECISIONS, normDecision, dateTimeET, etSyd } from "@/sentinel";

/** "2026-08-19 10:01:00 ET · 00:01:00 AEST" */
const when = (ts) => (ts ? `${dateTimeET(ts).slice(0, 10)} ${etSyd(ts)}` : "");

/** Decisions logged in the feed are history, so every badge is muted. Non-vocabulary labels stay neutral. */
function DecisionTag({ label }) {
  const d = normDecision(label);
  return DECISIONS[d] ? <DecisionBadge decision={d} size="compact" muted /> : <Badge>{String(label).toUpperCase()}</Badge>;
}

export default function Activity() {
  const { data: rows = [], isFetching, refetch } = useQuery({
    queryKey: ["pm-activity"],
    queryFn: api.pmActivity,
    refetchInterval: 30000,
  });

  return (
    <div className="sn-stack" style={{ gap: "var(--space-5)" }} data-testid="pm-activity">
      <PageHead
        crumb={["Project", "Activity"]}
        title="Activity"
        context="Project feed. Every Sentinel checkpoint decision is logged here automatically."
        actions={<Button icon={isFetching ? "Loader" : "RefreshCw"} onClick={() => refetch()} data-testid="pm-activity-refresh">Refresh</Button>}
      />

      {rows.length === 0 ? (
        <EmptyState icon="Activity" title="No activity yet" data-testid="pm-activity-empty">
          Run a checkpoint in the session desk and it will appear here.
        </EmptyState>
      ) : (
        <Panel title="Feed" icon="Activity" flush meta={<span className="sn-num">{rows.length}</span>}>
          <ol style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {rows.map((a, i) => (
              <li key={a.id || i} className="sn-dlog" data-testid={`pm-activity-row-${i}`}>
                <span className="sn-dlog-dot"><Icon name="Activity" size={14} /></span>
                <div className="sn-row" style={{ justifyContent: "space-between", alignItems: "flex-start", flexWrap: "nowrap" }}>
                  <h3 className="sn-dlog-t">{a.title}</h3>
                  {a?.meta?.decision && <DecisionTag label={a.meta.decision} />}
                </div>
                {a.detail && <p className="sn-dlog-b">{a.detail}</p>}
                <span className="sn-num sn-faint" style={{ gridColumn: 2, fontSize: 12 }}>{when(a.created_at)}</span>
              </li>
            ))}
          </ol>
        </Panel>
      )}
    </div>
  );
}
